"use client";

import { Award, HeartPulse, LifeBuoy, ShieldCheck, Users, Wrench } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurSafetyStandards() {
  const {
    ref: headRef,
    isVisible: headVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: statsRef,
    isVisible: statsVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const badges = [{
    icon: ShieldCheck,
    title: "Ασφαλείς Συναλλαγές",
    desc: "Απολαύστε απόλυτη σιγουριά με κρυπτογραφημένες πληρωμές κορυφαίων προδιαγραφών."
  }, {
    icon: Award,
    title: "Επίσημη Αδειοδότηση",
    desc: "Ταξιδέψτε με την εγγύηση ενός επίσημα αναγνωρισμένου πρακτορείου από τον ΕΟΤ."
  }, {
    icon: LifeBuoy,
    title: "Άμεση Επιβεβαίωση",
    desc: "Ολοκληρώστε την κράτησή σας και λάβετε το voucher άμεσα στο email σας."
  }, {
    icon: HeartPulse,
    title: "Υποστήριξη 24/7",
    desc: "Είμαστε στη διάθεσή σας κάθε στιγμή για να διασφαλίσουμε μια τέλεια διαμονή."
  }, {
    icon: Users,
    title: "Αποκλειστικές Προσφορές",
    desc: "Πρόσβαση σε επιλεγμένα καταλύματα με ειδικές τιμές μόνο για τα μέλη του HotelDeals."
  }, {
    icon: Wrench,
    title: "Εγγύηση Χαμηλότερης Τιμής",
    desc: "Εξασφαλίστε την καλύτερη τιμή της αγοράς μέσα από τις απευθείας συνεργασίες μας."
  }];
  return <section data-section-id="729" id="εγγύηση-και-ασφάλεια" className="relative overflow-hidden bg-background py-20 md:py-28 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        {}
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-2 lg:gap-16">
          {}
          <div ref={headRef} className={`transition-all duration-700 ease-out ${headVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            <p className="font-mono text-sm font-medium uppercase tracking-[0.2em] text-primary">
              02 &mdash; ΑΣΦΑΛΕΙΑ
            </p>
            <h2 className="mt-6 font-default text-4xl font-bold leading-[1.1] tracking-tighter text-foreground md:text-5xl lg:text-6xl">
              Εγγυημένη Εμπειρία και Αποκλειστική Πρόσβαση
            </h2>
            <p className="mt-8 max-w-xl text-base leading-relaxed text-muted-foreground md:text-lg font-default">
              Στο HotelDeals.gr, η εμπιστοσύνη είναι η βάση κάθε κράτησης. Παρακάμπτουμε τους μεσάζοντες για να σας προσφέρουμε όχι μόνο τις χαμηλότερες τιμές στην Ελλάδα, αλλά και την απόλυτη σιγουριά ότι η κράτησή σας είναι εγγυημένη και προστατευμένη.
            </p>
          </div>

          {}
          <div ref={gridRef} className="grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-5">
            {badges.map((badge, i) => {
            const Icon = badge.icon;
            return <div data-index={i} key={i} className={`group rounded-md border p-6 transition-all duration-700 ease-out hover:shadow-lg border-border bg-card ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
              transitionDelay: gridVisible ? `${i * 80}ms` : "0ms"
            }}>
                  <div className="flex h-12 w-12 items-center justify-center rounded-md bg-primary/10">
                    <Icon className="h-6 w-6 text-primary" strokeWidth={1.5} />
                  </div>
                  <h3 className="mt-5 font-default text-sm font-bold tracking-wider text-foreground">
                    {badge.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-muted-foreground font-default">
                    {badge.desc}
                  </p>
                </div>;
          })}
          </div>
        </div>

        {}
        <div ref={statsRef} className={`mt-20 border-t pt-12 md:mt-24 md:pt-16 transition-all duration-700 ease-out border-border ${statsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="grid grid-cols-1 gap-10 text-center sm:grid-cols-3 sm:gap-6 sm:text-left">
            <div data-index={0}>
              <div className="font-default text-5xl font-bold leading-none tracking-tighter text-foreground md:text-6xl lg:text-7xl">
                100%
              </div>
              <div className="mt-3 font-mono text-xs font-medium uppercase tracking-[0.18em] text-primary">
                ΑΣΦΑΛΕΙΑ
              </div>
            </div>
            <div data-index={1}>
              <div className="font-default text-5xl font-bold leading-none tracking-tighter text-foreground md:text-6xl lg:text-7xl">
                10+
              </div>
              <div className="mt-3 font-mono text-xs font-medium uppercase tracking-[0.18em] text-primary">
                ΕΤΗ ΕΜΠΕΙΡΙΑΣ
              </div>
            </div>
            <div data-index={2}>
              <div className="font-default text-5xl font-bold leading-none tracking-tighter text-foreground md:text-6xl lg:text-7xl">
                2.500.000+
              </div>
              <div className="mt-3 font-mono text-xs font-medium uppercase tracking-[0.18em] text-primary">
                ΞΕΝΟΔΟΧΕΙΑ
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}